import store from 'redux/store';
import t from 'react-translate';
import { SyncingStatus } from 'redux/schemas/models/lecture-page';
import { LecturePageMode } from 'lecture_pages/components';
import { yellow } from 'styles/global_defaults/colors';
import {
  getLecturePage, setUpdatingColors, unsetLecturePageAsCached, updateLecturePageFields,
} from '../../redux/actions/lecture-pages';
import { addAlertMessage } from '../../redux/actions/alert-messages';
import { AlertMessageType } from '../../redux/schemas/app/alert-message';
import LecturePageRouter from '../components/lecture-page-routes';

export default class LecturePageReactController {
  /* @ngInject */
  constructor(
    $scope,
    $stateParams,
    $state,
    ReportsManager,
    DiscussionsManager,
    CurrentCourseManager,
    PusherManager,
    TimedQuizzesManager,
    ReactLecturePageContext,
    humps,
    AlertMessages,
    $window,
  ) {
    const vm = this;
    vm.AlertMessages = AlertMessages;
    const courseId = CurrentCourseManager.course.id;
    const state = store.getState();
    const isContentManagementCollection = state.models.courses[$stateParams.catalogId]?.isContentManagementCollection;

    if (!isContentManagementCollection) {
      ReportsManager.getApprovalExercises(true);
      DiscussionsManager.initialize({ context: 'lecture', catalogId: $stateParams.catalogId });
      DiscussionsManager.initializePusherEvents(courseId);
      DiscussionsManager.initializeMentions();

      /**
       * This pusher is handling the multiple sessions in timed quiz when starting
       * a quiz. For more Info: https://novoed.atlassian.net/browse/NOV-53292.
       */
      PusherManager.currentUserChannel().bind('timed_quiz_new_window', multipleSessionsHandler);
      PusherManager.courseChannel(courseId).bind('lecture_page_sync_completed', lessonLibraryEventHandler);
      PusherManager.courseChannel(courseId).bind('lecture_page_link_completed', linkingCompletionHandler);
      PusherManager.courseChannel(courseId).bind('lecture_page_convert_completed', convertingCompletionHandler);
    }

    $scope.LecturePageRouter = LecturePageRouter;

    $scope.$on('$destroy', () => {
      if (!isContentManagementCollection) {
        DiscussionsManager.unsubscribeFromPusherEvents(courseId);
        PusherManager.currentUserChannel().unbind('timed_quiz_new_window');
        PusherManager.courseChannel(courseId).unbind('lecture_page_sync_completed', $scope.lessonLibraryEventHandler);
        PusherManager.courseChannel(courseId).unbind('lecture_page_link_completed', $scope.linkingCompletionHandler);
        PusherManager.courseChannel(courseId).unbind('lecture_page_convert_completed', $scope.convertingCompletionHandler);

        DiscussionsManager.resetSearchParams();
      }
    });

    function multipleSessionsHandler(pusherData) {
      humps.camelizeKeys(pusherData);

      if (
        pusherData.lecturePageId === $stateParams.lecturePageId
        && pusherData.action === 'activate_window'
        && pusherData.windowId !== TimedQuizzesManager?.currentQuiz?.windowId
      ) {
        ReactLecturePageContext.updateLecturePage();
      }
    }

    function linkingCompletionHandler(pusherData) {
      lessonLibraryEventHandler(pusherData, 'link');
    }

    function convertingCompletionHandler(pusherData) {
      lessonLibraryEventHandler(pusherData, 'convert');
    }

    function lessonLibraryEventHandler(pusherData, event) {
      const data = humps.camelizeKeys(pusherData);
      const lecturePage = store.getState().models.lecturePages[data.lecturePageId];
      const { mode } = store.getState().app.lecturePage;
      if (data.lecturePageId === $state.params.id) {
        if (event === 'link' && lecturePage?.hasContent) {
          // We are navigating to the lecture page when initiating the link.
          // So no need to fetch the lecture page again, just update the fields.
          store.dispatch(updateLecturePageFields({
            id: parseInt(data.lecturePageId, 10),
            patch: {
              syncingStatus: SyncingStatus.COMPLETED,
              hasUpdatedLink: true,
            },
          }));
        } else if (event === 'convert' && (mode !== LecturePageMode.VIEW)) {
          // updating the linked status, which will trigger the lecture page
          // re-fetch from lecture page container only in admin mode.
          store.dispatch(updateLecturePageFields({
            id: parseInt(data.lecturePageId, 10),
            patch: {
              isLinked: true,
            },
          }));
        } else {
          // Refetching the lecture page to get the updated data.
          store.dispatch(getLecturePage({
            catalogId: $stateParams.catalogId,
            lecturePageId: parseInt(data.lecturePageId, 10),
            mode: LecturePageMode.EDIT,
          }));
        }
      } else {
        if (event === 'convert' && (mode !== LecturePageMode.VIEW) && data.hasUpdatedLinks && data.lecturePageId) {
          store.dispatch(updateLecturePageFields({
            id: parseInt(data.lecturePageId, 10),
            patch: {
              isLinked: true,
            },
          }));
        }
        /**
         * Unseating the lecture page's cache status to get updated data on the
         * next visit to that lecture page.
         */
        store.dispatch(unsetLecturePageAsCached(data.lecturePageId));
      }
    }
  }
}
